import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "src/components/ui/button";
import { useBuyerRequirements } from "src/features/properties/hooks/useBuyerRequirements";
import { BuyerRequirementsTable } from "src/features/properties/components/BuyerRequirementsTable";
import { DeletePropertyModal } from "src/features/properties/components/DeletePropertyModal";
import { BuyerRequirementDrawer } from "src/features/properties/components/BuyerRequirementDrawer";

export default function BuyerRequirementsPage() {
  const [page, setPage] = useState(1);
  const { data, loading, fetch } = useBuyerRequirements();
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => {
    fetch({ page, per_page: 20 });
  }, [fetch, page]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-900">Buyer Requirements</h2>
        <Button onClick={() => { setEditRecord(null); setIsDrawerOpen(true); }}>
          <Plus className="h-4 w-4 mr-1.5" />
          Add Requirement
        </Button>
      </div>

      <BuyerRequirementsTable
        requirements={data?.requirements || []}
        meta={data?.meta}
        loading={loading}
        page={page}
        onPageChange={setPage}
        onShow={(record) => { setEditRecord(record); setIsDrawerOpen(true); }}
        onEdit={(record) => { setEditRecord(record); setIsDrawerOpen(true); }}
        onDelete={setDeleteRecord}
        onNewRequirement={() => { setEditRecord(null); setIsDrawerOpen(true); }}
      />

      <DeletePropertyModal
        open={!!deleteRecord}
        onClose={() => setDeleteRecord(null)}
        record={deleteRecord}
        type="requirement"
        onSuccess={() => fetch({ page, per_page: 20 })}
      />

      <BuyerRequirementDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        requirement={editRecord}
        onSuccess={() => fetch({ page, per_page: 20 })}
      />
    </div>
  );
}
